import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/about';
import Features from './pages/Features';
import Benefits from './pages/Benefits';
import Contact from './pages/Contact';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AnimationObserver() {
  const location = useLocation();

  useEffect(() => {
    // Re-initialize observer on route change
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('aos-animate');
        }
      });
    }, observerOptions);
    
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      document.querySelectorAll('[data-aos]').forEach(el => {
        el.classList.remove('aos-animate'); // Reset animation
        observer.observe(el);
      });
    }, 100);
    
    return () => observer.disconnect();
  }, [location.pathname]); // Re-run when route changes

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AnimationObserver />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/features" element={<Features />} />
            <Route path="/benefits" element={<Benefits />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
